import { ActionIcon, Group } from '@mantine/core';
import {
  IconBell,
  IconCalendar,
  IconPlus,
  IconSearch,
  IconUser,
} from '@tabler/icons-react';
import { primaryColor } from '../../constants/theme';
import { useLocation, useNavigate } from 'react-router-dom';
import { cloneElement, useMemo } from 'react';
import { PageRoutes } from '../../constants/routes';
import { useApp } from '../../context/AppContext';

export const MobileNav = () => {
  const navigate = useNavigate();
  const { profile } = useApp();

  const showAvailability = profile?.isProfessional !== false;

  return (
    <Group
      w="100%"
      h="60px"
      bg={'white'}
      justify="space-evenly"
      style={{ borderTop: '2px solid #e0e0e0', flexShrink: 0 }}
    >
      <NavButton Icon={<IconSearch />} route={PageRoutes.SEARCH} />
      <NavButton Icon={<IconCalendar />} route={PageRoutes.BOOKINGS} />
      {showAvailability && (
        <ActionIcon
          size={50}
          radius="xl"
          variant="filled"
          color={primaryColor}
          onClick={() => navigate(PageRoutes.AVAILABILITY)}
        >
          <IconPlus />
        </ActionIcon>
      )}
      <NavButton Icon={<IconBell />} route={PageRoutes.NOTIFICATIONS} />
      <NavButton Icon={<IconUser />} route={PageRoutes.PROFILE} />
    </Group>
  );
};

interface NavButtonProps {
  Icon: React.ReactElement;
  route: string;
}

export const NavButton = ({ Icon, route }: NavButtonProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = useApp();

  const isActive = useMemo(() => {
    if (route === PageRoutes.PROFILE) {
      return (
        location.pathname === route &&
        location.search.includes(`professionalId=${profile?.id}`)
      );
    }
    return location.pathname === route;
  }, [location.pathname, location.search]);

  const onClick = () => {
    if (location.pathname !== route || route === PageRoutes.PROFILE) {
      if (route === PageRoutes.PROFILE) {
        navigate(`${PageRoutes.PROFILE}?professionalId=${profile?.id}`);
        return;
      } else {
        navigate(route);
      }
    }
  };

  return (
    <ActionIcon
      size={50}
      radius="md"
      variant="transparent"
      color="grey"
      onClick={onClick}
    >
      {cloneElement(Icon, {
        color: isActive ? primaryColor : 'grey',
      })}
    </ActionIcon>
  );
};
